import "./overviewBannerStyles.scss";
import BSULogo from "../../../../assets/Ball State University - Horizontal Red 2.svg";

const OverviewBanner = () => {
  return (
    <div className="overview-banner">
      <div className="section-header ">
        <h2>
          Integrated Academic Support, Career ENhancement, <br /> and Personal
          Development (I-ASCEND)
        </h2>
      </div>
      <div className="content-wrapper">
        <div className="image-wrapper">
          <img src={BSULogo} alt="Ball State University Logo" />
        </div>
      </div>
    </div>
  );
};

export default OverviewBanner;
